import axios from 'axios'
import has from 'lodash.has'
import {
  clearSessionToken,
  getSessionAccessToken,
  isTokenExpired,
  redirectToAuthService,
  sessionHasValidToken,
} from '../auth/utils'
import { ROUTE_SESSION_EXPIRED } from '../routes/constants'

const instance = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

const request = async (options) => {
  const { endpoint, token = getSessionAccessToken(), data, authorizationMethod = 'Bearer', method, ...rest } = options
  const requestMethod = method ? method.toUpperCase() : 'GET'

  instance.interceptors.request.use(
    (config) => {
      if (isTokenExpired() && !window.location.href.includes(ROUTE_SESSION_EXPIRED)) {
        window.location.href = ROUTE_SESSION_EXPIRED
        return
      }

      if (!sessionHasValidToken() && !window.location.href.includes(ROUTE_SESSION_EXPIRED)) {
        return redirectToAuthService()
      }

      return config
    },
    (error) => Promise.reject(error)
  )

  instance.defaults.headers.common.Authorization = `${authorizationMethod} ${token}`
  if (requestMethod !== 'GET') {
    delete instance.defaults.headers.common['Content-Type']
  }

  try {
    const response = await instance.request({
      url: endpoint,
      method: requestMethod,
      data,
      ...rest,
    })
    return response.data
  } catch (error) {
    // network error
    if (!has(error, 'response.status')) {
      throw new Error(`Network error - ${endpoint}: ${error.message}`)
    }

    if (error?.response?.status === 401) {
      // token not valid anymore
      clearSessionToken()
    }

    // api error
    if (error.response) {
      const message = JSON.stringify(error.response)
      throw new Error(`${endpoint}: ${message}`)
    }

    // other
    throw error
  }
}

export default request
